export const track = (eventName: string, attributes?: Record<string, unknown>) => {
	if (typeof window?.bynder?.track === 'function') {
		window.bynder.track(eventName, attributes);
	}
};
